export default "__VITE_ASSET__Bhfz0Jhf__"